import React from 'react';
import { InstagramIcon, YoutubeIcon, MusicIcon } from 'lucide-react';
const TiktokIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-13" data-mp="3ggtx2ezk5d3n">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-14" data-mp="36qhg0wqyc229" />
  </svg>;
export function Footer() {
  return <footer className="bg-brand-black pt-20 pb-10 px-6 md:px-12 border-t border-brand-white/10" data-id="element-15" data-mp="3ug3f7k7bqha9">
      <div className="max-w-screen-2xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-12 mb-20" data-id="element-16" data-mp="37o6cv1anxdd">
        <div className="text-center md:text-left" data-id="element-17" data-mp="3le2katzkc7br">
          <p className="text-brand-muted tracking-widest uppercase text-[12px]" data-id="element-18" data-mp="3qcx8yck7oq3s">
            Booking/Management: Dylan.buckley@weedwaster.com
          </p>
        </div>

        <div className="flex gap-6" data-id="element-19" data-mp="2a1ji55nwno0v">
          <a href="https://www.instagram.com/ruslansilvr/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all" data-id="element-20" data-mp="2eyjprl0ekyu3">
            <InstagramIcon className="w-5 h-5" data-id="element-21" data-mp="3v7gbfp413q40" />
          </a>
          <a href="https://www.tiktok.com/@ruslansilvr?lang=en" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all" data-id="element-22" data-mp="3v5n5kc18p9x2">
            <TiktokIcon className="w-5 h-5" data-id="element-23" data-mp="33e4p5rpsiq3" />
          </a>
          <a href="https://www.youtube.com/@ruslansilvr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all" data-id="element-24" data-mp="htd0j1vsri2e">
            <YoutubeIcon className="w-5 h-5" data-id="element-25" data-mp="mrwrjgp8zk1m" />
          </a>
          <a href="#" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all" data-id="element-26" data-mp="mthlb43qmyyf">
            <MusicIcon className="w-5 h-5" data-id="element-27" data-mp="yupnyh427kju" />
          </a>
        </div>
      </div>

      <div className="max-w-screen-2xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-brand-white/10 text-brand-muted text-xs tracking-widest uppercase" data-id="element-28" data-mp="13siq8z28rueu">
        <p data-id="element-29" data-mp="1ckt0ggd4zzw3">
          &copy; {new Date().getFullYear()} RuslanSilvr. All rights reserved.
        </p>
        <div className="flex gap-6" data-id="element-30" data-mp="1hje1gi07qnll">
          <a href="#" className="hover:text-brand-white transition-colors" data-id="element-31" data-mp="1hmig69bb11qi">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-brand-white transition-colors" data-id="element-32" data-mp="1rilfz8ioooaa">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}